var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "电子签章授权",
        footer: null,
        width: 560,
        closable: false,
        keyboard: false,
        maskClosable: false
      },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c("div", [
        _vm._v(
          "请授权平台为您开通电子签章服务，以便您在平台上使用数字证书签署电子合同。"
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "spaceLeft" },
        [
          _c("span", [_vm._v("授权码：")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-box" },
            [
              _c("a-input", {
                staticStyle: { width: "300px" },
                model: {
                  value: _vm.code,
                  callback: function($$v) {
                    _vm.code = $$v
                  },
                  expression: "code"
                }
              }),
              _vm._v(" "),
              _c(
                "button-load",
                {
                  staticClass: "input-btn",
                  attrs: {
                    type: "primary",
                    disabled: _vm.countDisabled,
                    size: "small"
                  },
                  on: { clickHandle: _vm.onFetchCode }
                },
                [
                  _c("template", { slot: "lable" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.counter > 0,
                            expression: "counter>0"
                          }
                        ]
                      },
                      [_vm._v(_vm._s(_vm.counter))]
                    ),
                    _vm._v(
                      _vm._s(_vm.countDisabled ? "重新获取" : "获取授权码") +
                        "\n                "
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("button-load", {
            staticStyle: { "margin-left": "8px" },
            attrs: {
              type: "primary",
              disabled: _vm.code.length == 0,
              lable: "确定"
            },
            on: { clickHandle: _vm.okModal }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-left": "60px" } }, [
        _vm._v(
          "短信验证码将发送至：" +
            _vm._s(
              _vm._f("phoneFilter")(
                _vm.$store.getters["home/getUserObj"].signMobile
              )
            )
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sign-margin" }, [
        _c(
          "a",
          {
            staticClass: "sign-margin",
            attrs: {
              target: "_blank",
              href: "https://www.anxinsign.com/Web/about/serviceAgreement"
            }
          },
          [_vm._v("安心签平台服务协议")]
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "sign-margin",
            attrs: {
              target: "_blank",
              href: "https://www.anxinsign.com/Web/about/secretDeclare"
            }
          },
          [_vm._v("安心签平台隐私声明")]
        ),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "sign-margin",
            attrs: {
              target: "_blank",
              href: "https://www.anxinsign.com/Web/about/serviceAgreement"
            }
          },
          [_vm._v("CFCA数字证书服务协议")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b94068e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b94068e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sign/eleSign.vue
// module id = +9b7
// module chunks = 1